import * as React from 'react'
import { Accordion } from 'react-bootstrap'

const FaqAccordion = ({ faq, index }) => {
  //Contenful Needs to be fixed --inconsistent data is forcing us to set conditionals in the variable below
  const faqSingle = faq.node ? faq.node : faq

  return (
    <Accordion.Item eventKey={index}>
      <Accordion.Header>{faqSingle.question}</Accordion.Header>
      <Accordion.Body>
        <div
          dangerouslySetInnerHTML={{
            __html: faqSingle.answer,
          }}
        />
      </Accordion.Body>
    </Accordion.Item>
  )
}

export default FaqAccordion
